<template>
    <div class="sidebar-detail">
        <!-- :title="`${detailInfo.name || '----' } ${qrCode}`" -->
        <detail-header
            v-if="detailInfo"
            title="Trial"
            @refreshDetailPage="refreshDetailPage"
            @closeDetailPage="closeDetailPage"
        />

        <div v-if="detailInfo">
            <p class="detail-title">Details</p>
            <div>
                <table class="recording-detail-table">
                    <tr>
                        <td>Id</td>
                        <td>{{ detailInfo.id }}</td>
                    </tr>
                    <tr>
                        <td>Trial Number</td>
                        <td>{{ detailInfo.trialNumber }}</td>
                    </tr>
                    <tr>
                        <td>Title</td>
                        <td>{{ detailInfo.title || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Objective</td>
                        <td>{{ detailInfo.objective || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Mating Design</td>
                        <td>{{ (detailInfo.matingDesign||{}).name || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Location</td>
                        <td>{{ (detailInfo.location||{}).name || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Person In Charge</td>
                        <td>{{ (detailInfo.employeeInCharge||{}).name || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Start Date</td>
                        <td>{{ $_getMyrDateFormat(detailInfo.startDate) || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Complete Date</td>
                        <td>{{ $_getMyrDateFormat(detailInfo.completeDate) || "-" }}</td>
                    </tr>
                    <tr>
                        <td class="table-section" colspan="2">Status</td>
                    </tr>
                    <tr>
                        <td>Status</td>
                        <td>{{ (detailInfo.researchStatus||{}).name || "-" }}</td>
                    </tr>
                </table>
            </div>

            <p class="detail-title detail-title-pd">Yearly Yield Chart</p>
            <div v-if="YearlyYieldChartData" class="user-datetime-container">
                <table>
                    <tr>
                        <td colspan="2">
                            <div>
                                <v-btn-toggle v-model="toggleExclusive" class="cross-type-btns" :dense="true">
                                    <v-btn v-for="(crossType, index) in crossTypes" :key="'crossType' + index" small @click="handleClickCrossType(crossType)">{{ crossType.name }}</v-btn>
                                </v-btn-toggle>
                                <best-4-consecutive-year-small ref="best-4-consecutive-year-small" :yearly-yield-chart-data="YearlyYieldChartData" :cross-type-name="crossTypeName" />
                            </div>
                        </td>
                    </tr>
                </table>
            </div>

            <p class="detail-title detail-title-pd">Date Time</p>
            <div class="user-datetime-container">
                <table>
                    <tr>
                        <td>Modified</td>
                        <td>{{ $_getDateTimeFormat(detailInfo.lastModificationTime) }} {{ $t('detail.by') }} {{ (detailInfo.lastModifierUser||{}).userName || '-' }}</td>
                    </tr>
                    <tr>
                        <td>Created</td>
                        <td>{{ $_getDateTimeFormat(detailInfo.creationTime) }} {{ $t('detail.by') }} {{ (detailInfo.creatorUser||{}).userName || '-' }}</td>
                    </tr>
                </table>
            </div>

            <div class="detail-btn-container">
                <detail-btn class="detail-btn" :param-id="detailInfo.id" param-name="id" page-name="TrialDetail" />
            </div>
        </div>
    </div>
</template>

<script>
import DetailButton from "@/components/Button/DetailButton";
import DetailHeader from "./DetailHeader";
import { trialGet } from "@/api/trial";
import { crossTypeGetAllUnderTrial } from "@/api/cross_type";
import YieldYearMeanTable from "@/components/Chart/YieldYearMeanTable.vue";
import Best4ConsecutiveYearSmall from "@/components/Chart/Best4ConsecutiveYearSmall.vue";

export default {
    components: {
        "detail-header": DetailHeader,
        "detail-btn": DetailButton,
        "best-4-consecutive-year-small": Best4ConsecutiveYearSmall,
    },
    props: {
        infoSidebarId: {
            type: Number | String
        }
    },
    data() {
        return {
            detailInfo: null,

            warningMsg: null,
            YearlyYieldChartData: null,
            toggleExclusive: 0,
            crossTypes: [{ id: null, name: "All" }],
            selectedCrossType: null
        };
    },
    computed: {
        crossTypeName() {
            return this.selectedCrossType?.name;
        }
    },
    watch: {
        infoSidebarId: {
            immediate: true,
            handler() {
                this.getDetails();
                this.crossTypes = [{ id: null, name: "All" }];
                this.getAllCrossTypeUnderTrial();
            },
        }
    },
    methods: {
        async getDetails() {
            if (this.infoSidebarId) {
                var res = await trialGet({ Id: this.infoSidebarId });
                if (res) {
                    this.detailInfo = res;
                }
            }
        },
        async getAllCrossTypeUnderTrial() {
            let res = await crossTypeGetAllUnderTrial({ "TrialId": this.infoSidebarId });
            if (res) {
                if (res.length == 0) {
                    this.warningMsg = [...this.warningMsg, "Progeny cross type was not detected"];
                }
                else {
                    this.crossTypes = [...this.crossTypes, ...res];
                    this.selectedCrossType = this.crossTypes[0];
                }
                this.getYearlyYieldChart({ "CrossTypeId": this.crossTypes[0]?.id });
            }
        },
        getYearlyYieldChart(crossTypeParams) {
            console.log("get yearly yield");
            axios({
                method: "GET",
                url: "Trial/GetYearlyYieldChart",
                cache: {
                    ignoreCache: true,
                },
                params: {
                    Id: this.infoSidebarId,
                    ...crossTypeParams
                }
            })
                .then( (response) => {
                    if (response.data.result.yearData.length > 0) {
                        this.YearlyYieldChartData = response.data.result;
                    }
                });
        },
        refreshDetailPage() {
            this.getDetails();
        },
        closeDetailPage() {
            this.$store.dispatch("info_sidebar/setInfoSidebar");
        },
        handleClickCrossType(crossType) {
            this.selectedCrossType = crossType;
            this.getYearlyYieldChart({ "CrossTypeId": crossType.id });
        }
    }
};
</script>

<style scoped>
.stepper-container {
    padding: var(--space-16) 0;
}
</style>


// WEBPACK FOOTER //
// src/components/SidebarDetail/TrialSidebar.vue